// extracted by mini-css-extract-plugin
export default {"tittleMonetization":"priceCourse_tittleMonetization__DJICY","infoPrice":"priceCourse_infoPrice__cGkEq"};